import React from 'react';
import { Send } from '@withjoy/joykit/icons';
import { TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { GetDataForThanksForRSVPQuery } from '@graphql/generated';
import useLoadGoogleFont from '@apps/saveTheDate/hooks/useLoadGoogleFont';

interface HeaderProps
  extends Readonly<{
    message: string;
    haveLinkOrRegistry?: boolean;
    queryData?: GetDataForThanksForRSVPQuery;
  }> {}

export const Header: React.FC<HeaderProps> = ({ message, haveLinkOrRegistry, queryData }) => {
  const fontFamily = queryData?.eventByName?.eventDesign?.font?.fontFamily ?? 'PT Serif';
  useLoadGoogleFont([`${fontFamily}:400`]);
  return (
    <>
      <Send
        size="xl"
        marginTop={haveLinkOrRegistry ? 7 : 9}
        marginBottom={5}
      />
      <TextV2
        typographyVariant="hed6"
        fontWeight={600}
        fontSize={pxToRem(26)}
        marginBottom={haveLinkOrRegistry ? [10, null, pxToRem(24)] : 24}
        textAlign="center"
        maxWidth="250px"
      >
        {message}
      </TextV2>
    </>
  );
};
